"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Select_1 = __importDefault(require("components/core/inputs/Select"));
var PrefsStore_1 = require("stores/PrefsStore");
var HomeSort = function (_a) {
    var sortType = _a.sortType, onChange = _a.onChange;
    return (react_1.default.createElement("div", { className: "home-sort" },
        react_1.default.createElement(Select_1.default, { name: "sort-by", value: sortType, onChange: onChange, options: Object.keys(PrefsStore_1.QuerySortTypes).filter(function (key) { return isNaN(parseInt(key)); })
                .map(function (key) { return ({
                value: PrefsStore_1.QuerySortTypeValues[key],
                text: PrefsStore_1.QuerySortTypes[key]
            }); }) })));
};
exports.default = HomeSort;
